const ERROR = {
            UNKNOWN_SERVER_ERROR_500: "Unknown server error",
            EMPTY_STUDENT_LIST_ERROR: "student list Empty error",
            USER_MISSING_ERROR: "user missing error",
            INVALID_AUTHENTICATION_INFORMATION_ERROR: "Invalid authentication error",
            INVALID_AUTHENTICATION_ERROR: "Invalid authentication error",

};
export default ERROR;